import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { FigureRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: FigureRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function FigureRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "figure",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("FigureRegionTypeCard.title")}
      description={t("FigureRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
